import { FC } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useIntl } from 'react-intl'

import { ID } from '@models/base'
import { Option } from '@models/option'
import { QueueModel } from '@models/queue'

import {
  QueueNumberCompleteForm,
  QueueNumberCompleteFormShape,
} from '@modules/queues/components/QueueNumberCompleteForm'

type Props = {
  isShow: boolean
  queueId: ID
  isEnding?: boolean
  preferredNextQueue?: QueueModel
  onClose: () => void
  onSubmit: (values: QueueNumberCompleteFormShape) => Promise<void>
}

const QueueNumberCompleteFormModal: FC<Props> = ({
  isShow,
  isEnding,
  queueId,
  preferredNextQueue,
  onClose,
  onSubmit,
}) => {
  const intl = useIntl()

  const initialValues: QueueNumberCompleteFormShape = {
    next_queue_id: preferredNextQueue
      ? new Option({
          label: preferredNextQueue.name,
          value: preferredNextQueue.id,
        })
      : undefined,
  }

  return (
    <Modal
      show={isShow}
      centered
      size="lg"
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title as="h3">{intl.formatMessage({ id: 'queue_node.complete.title' })}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="mx-15 my-7">
        <QueueNumberCompleteForm
           queueId={queueId}
          isEnding={isEnding}
          onHide={onClose}
          onSubmit={onSubmit}
          initialValues={initialValues}
        />
      </Modal.Body>
    </Modal>
  )
}

export { QueueNumberCompleteFormModal }
